/**
 * Starter prompts shown on an empty conversation (the tappable chips ChatGPT
 * and Claude show before the first message). They are plain questions, not
 * answers: tapping one only sends the question to the same endpoint a typed
 * message uses, so the answer still comes from the knowledge base.
 */
export const STARTER_PROMPTS: readonly string[] = [
  'What causes an ADM on an exchange or reissue?',
  'How do I price a reissue after a schedule change?',
  'Which Sabre entries refund a ticket?',
  'How do I avoid a debit memo on a name correction?',
];
